import React, { SVGProps } from 'react'

const Purchase = (props?: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.4225 2.74417C11.3452 2.66663 11.2534 2.60514 11.1523 2.56324C11.0512 2.52133 10.9428 2.49984 10.8333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V10.8333C2.5 11.055 2.5875 11.2667 2.74417 11.4225L9.41083 18.0892C9.48804 18.1668 9.57984 18.2284 9.68096 18.2705C9.78207 18.3126 9.89049 18.3342 10 18.3342C10.1095 18.3342 10.2179 18.3126 10.319 18.2705C10.4202 18.2284 10.512 18.1668 10.5892 18.0892L18.0892 10.5892C18.1666 10.5118 18.2281 10.42 18.27 10.3189C18.3119 10.2178 18.3335 10.1094 18.3335 10C18.3335 9.89056 18.3119 9.78219 18.27 9.68109C18.2281 9.57999 18.1666 9.48816 18.0892 9.41083L11.4225 2.74417ZM10 16.3217L4.16667 10.4883V4.16667H10.4883L16.3217 10L10 16.3217Z"
      fill="#DB2357"
    />
    <path
      d="M7.08 8.33328C7.77266 8.33328 8.33417 7.77177 8.33417 7.07912C8.33417 6.38646 7.77266 5.82495 7.08 5.82495C6.38735 5.82495 5.82584 6.38646 5.82584 7.07912C5.82584 7.77177 6.38735 8.33328 7.08 8.33328Z"
      fill="#DB2357"
    />
  </svg>
)

export default Purchase
